const issueBaseline = [
    {
        key: 'antivirus-protection-mode-is-turned-on',
        url: 'https://localhost:40001/ui/user-guide/index?#s%E1%BB%AD-d%E1%BB%A5ng-control-panel',
        content: [
            {
                vi: 'Truy cập trang Cài đặt tại: Windows Security\\Virus & threat protection settings',
                en: 'Open Windows Defender Settings page: Windows Security\\Virus & threat protection settings',
            },
            {
                vi: 'Gạt công tắc sang ON: Real-time protection, Cloud-based Protection, Sample submission',
                en: 'Switch ON: Real-time protection, Cloud-based Protection, Sample submission'
            },
        ],
        quickFix: true
    },
    {
        key: 'bitlocker-is-enabled',
        url: 'https://localhost:40001/ui/user-guide/index?#2-b%E1%BA%ADt-bitlocker',
        content: [
            {
                vi: 'Truy cập: Control Panel\\Bitlocker Drive Encryption',
                en: 'Open: Control Panel\\Bitlocker Drive Encryption',
            },
            {
                vi: 'Click Turn on Bitlocker',
                en: 'Click Turn on Bitlocker'
            },
            {
                vi: 'Làm theo hướng dẫn trên màn hình',
                en: 'Follow the instructions'
            }
        ],
        quickFix: true
    },
    {
        key: 'uac-is-turned-on',
        url: 'https://localhost:40001/ui/user-guide/index?#3-b%E1%BA%ADt-user-account-control-uac',
        content: [
            {
                vi: 'Truy cập trang Cài đặt tại: Control Panel\\User Accounts\\User Accounts\\Change User Account Control settings',
                en: 'Open User Account Control Settings page: Control Panel\\User Accounts\\User Accounts\\Change User Account Control settings',
            },
            {
                vi: 'Kéo thanh trượt lên mức 3 (như hình minh họa)',
                en: 'Set the UAC switch to 3rd position (as shown on below image)'
            },
            {
                vi: 'Bấm OK',
                en: 'Click Ok'
            },
        ],
        quickFix: true
    },
    {
        key: 'os-security-is-up-to-date',
        url: 'https://localhost:40001/ui/user-guide/index?#4-b%E1%BA%ADt-windows-update',
        content: [
            {
                vi: 'Truy cập trang Cài đặt tại: Windows Security\\Virus & threat Protection',
                en: 'Open User Account Control Settings page: Windows Security\\Virus & threat Protection',
            },
            {
                vi: 'Bấm Install Update',
                en: 'Click Install Update'
            },
        ],
        quickFix: true
    },
    {
        key: 'hotspot-is-turned-off',
        url: 'https://localhost:40001/ui/user-guide/index?#5-t%E1%BA%AFt-hotspot',
        content: [
            {
                vi: 'Truy cập trang Cài đặt tại: Settings\\Network & Internet\\Mobile Hotspot',
                en: 'Open Mobile Hotspot Settings page: Settings\\Network & Internet\\Mobile Hotspot',
            },
            {
                vi: 'Gạt công tắc Mobile Hotspot sang Off',
                en: 'Switch off Mobile Hotspot'
            },
        ],
        quickFix: true
    },
    {
        key: 'shared-folder-is-turned-off',
        url: 'https://localhost:40001/ui/user-guide/index?#6-t%E1%BA%AFt-file-and-printer-sharing',
        content: [
            {
                vi: 'Truy cập trang Cài đặt tại: Control Panel\\All Control Panel Items\\Network and Sharing Center\\Advanced sharing settings',
                en: 'Open Settings page: Control Panel\\All Control Panel Items\\Network and Sharing Center\\Advanced sharing settings'
            },
            {
                vi: 'Chọn Turn off file and printer sharing',
                en: 'Select Turn off file and printer sharing'
            },
            {
                vi: 'Bấm Save changes',
                en: 'Click Save changes'
            }
        ],
        quickFix: false
    },
    {
        key: 'network-connection-is-secured',
        url: ''
    },
    {
        key: 'external-storage-is-not-used',
        url: '',
        content: [
            {
                vi: 'Vui lòng rút bộ nhớ ngoài (USB, HDD, SSD, …) để khắc phục vấn đề.',
                en: 'Your device is not allowed to connect to external storage (USB, HDD, SSD,...). Please remove the external storage to resolve this issue'
            }
        ],
        quickFix: true
    },
    {
        key: 'os-version-is-windows-10-or-above',
        url: '',
        quickFix: true
    },
    {
        key: 'camera-is-turned-off',
        url: '',
        quickFix: false
    },
    {
        key: 'user-password-is-set',
        url: 'https://localhost:40001/ui/user-guide/index?focusContent=true#671-%C4%91%E1%BA%B7t-m%E1%BA%ADt-kh%E1%BA%A9u-%C4%91%C4%83ng-nh%E1%BA%ADp-tr%C3%AAn-m%C3%A1y-macos',
        quickFix: false
    },
    {
        key: 'bluetooth-is-turned-off',
        url: '',
        quickFix: false
    }
]

export default issueBaseline;
